var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset187(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.14 118.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f55d4;opacity:0.15;}.cls-2{fill:#fff;}.cls-3{fill:#3e6177;}.cls-4,.cls-6{fill:#2f55d4;}.cls-5{fill:#d5dfeb;}.cls-6{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 187") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -10.66,
    y: 34.29,
    width: 147,
    height: 50,
    rx: 25,
    ry: 25,
    transform: "translate(-23.52 61.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "30.84 77.8 30.84 38.8 93.84 39.3 93.84 76.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.61 110.14 47.99 108.66 61.34 85.08 75.08 108.43 72.5 109.95 61.39 91.08 50.61 110.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 54.34,
    y: -8.71,
    width: 14,
    height: 80,
    rx: 7,
    ry: 7,
    transform: "translate(92.64 -30.05) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.84,70.29a6.5,6.5,0,1,1,6.5-6.5A6.51,6.51,0,0,1,103.84,70.29Zm0-10a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,103.84,60.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.84,69.29a6.5,6.5,0,1,1,6.5-6.5A6.51,6.51,0,0,1,15.84,69.29Zm0-10a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,15.84,59.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.59,
    cy: 79.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 97.59,
    cy: 13.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 21.59,
    cy: 52.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.34,40.29h-66a8.5,8.5,0,1,1,0-17h66a8.5,8.5,0,0,1,0,17Zm-66-14a5.51,5.51,0,0,0-5.5,5.5h0a5.51,5.51,0,0,0,5.5,5.5h66a5.5,5.5,0,0,0,0-11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.05,
    y: 43.29,
    width: 14,
    height: 80,
    rx: 7,
    ry: 7,
    transform: "translate(145.34 21.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94,92.29H28a8.5,8.5,0,1,1,0-17H94a8.5,8.5,0,1,1,0,17Zm-66-14a5.51,5.51,0,0,0-5.5,5.5h0a5.51,5.51,0,0,0,5.5,5.5H94a5.5,5.5,0,0,0,0-11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.34,
    y: 29.29,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.34,
    y: 29.29,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.34,
    y: 29.29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.34,
    y: 38.79,
    width: 3,
    height: 39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 91.34,
    y: 39.29,
    width: 3,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 44.05,
    y: 54.79,
    width: 27.59,
    height: 3,
    transform: "translate(-22.81 59.47) rotate(-46.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 53.5,
    y: 58.29,
    width: 17.69,
    height: 3,
    transform: "translate(-23.88 65.05) rotate(-47.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.87,
    y: 33.88,
    width: 2,
    height: 12.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.87,
    y: 48.38,
    width: 2,
    height: 5.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.87,
    y: 55.63,
    width: 2,
    height: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.17,
    cy: 31.95,
    r: 26.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.08,
    cy: 31.95,
    r: 21.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.17,54.68A22.73,22.73,0,1,1,48.91,31.95,22.76,22.76,0,0,1,26.17,54.68Zm0-42.47A19.73,19.73,0,1,0,45.91,31.95,19.76,19.76,0,0,0,26.17,12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.25,41.43a1.92,1.92,0,0,1-1.1-.35l-7.67-5.37a1.5,1.5,0,0,1,1.72-2.46L24,38,35.14,23.18a1.5,1.5,0,1,1,2.4,1.8L25.79,40.65A1.92,1.92,0,0,1,24.25,41.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset187);
export default __webpack_public_path__ + "static/media/Asset187.7219ef45e29bbc1b7e276096b2d1e5eb.svg";
export { ForwardRef as ReactComponent };